module.exports = __webpack_public_path__ + "img/home.b908f642.svg";